import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/NewLiveValueSun.svg"

const NewLiveValueSun: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 80 80'} component={Icon} {...props} fill="currentColor" />
export default NewLiveValueSun
